export default __webpack_public_path__ + "static/media/bressart.76296a2e.png";